import React, { useEffect, useState } from 'react'
import styles from './LoginPage.module.css';
import Footer from '../../Layout/Footer';

import logo from '../../assets/logo/trea-logo.png';

import TextField from '@mui/material/TextField';
import FormControl from '@mui/material/FormControl';
import { Button, Alert, AlertTitle } from '@mui/material';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';

import { useNavigate, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import { authenticate } from '../../store/auth-actions';

const bannerTitle = 'TREA Ordering Management System'

const LoginPage = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();

    const authUser = useSelector(state => state.auth.authUser);
    const isAuthenticating = useSelector(state => state.auth.req_loading);
    const reqError = useSelector(state => state.auth.req_error)

    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');

    const [rememberMe, setRememberMe] = useState(!!localStorage.getItem('savedEmail'))

    const getFriendlyError = (rawError) => {
        if (!rawError) return '';

        if (typeof rawError === 'string') {
            if (rawError.startsWith('INVALID_PASSWORD')) {
                return 'Email or password is incorrect.';
            }

            if (rawError.startsWith('USER_NOT_FOUND')) {
                return 'No account was found with that email address.';
            }
        }

        return 'Unable to sign in. Please check your details and try again.';
    };


    const loginHandler = (e) => {
        e.preventDefault();

        if (email !== '' && password !== '') {
            if (rememberMe) {
                localStorage.setItem('savedEmail', email);
            } else {
                localStorage.removeItem('savedEmail');
            }
            dispatch(authenticate(email, password));
        }
    }

    /**
     * If user originally accessing /order/ABC but got timed out and returned to login,
     * after logging back in, it will bring him back to the original page he wants to visit.
     */
    useEffect(() => {
        if (authUser) {
            const from = location.state?.from?.pathname || '/';
            navigate(from, { replace: true });
        }
    }, [authUser, navigate, location.state])

    useEffect(() => {
        if (localStorage.getItem('savedEmail')) {
            setEmail(localStorage.getItem('savedEmail'))
        }
    }, [])

    return (
        <form className={styles.main} onSubmit={loginHandler}>
            <header className={styles.header}>
                {bannerTitle}
            </header>
            <section className={styles.section}>
                <img src={logo} alt="logo" className={styles.img}></img>
                <hr className={styles.hr} />
                <FormControl variant="standard" className={styles.form}>
                    <TextField
                        label="Email"
                        id="email"
                        name="email"
                        variant="standard"
                        value={email}
                        onChange={(e) => { setEmail(e.target.value) }}
                        sx={{ marginBottom: '16px' }}
                    />

                    <TextField
                        label="Password"
                        id="password"
                        variant="standard"
                        name="password"
                        type="password"
                        value={password}
                        onChange={(e) => { setPassword(e.target.value) }}
                        sx={{ marginBottom: '16px' }}
                    />

                    <FormControlLabel
                        control={<Checkbox
                            color="success"
                            checked={rememberMe}
                            onChange={(e) => setRememberMe(e.target.checked)} />}
                        label="Remember Me" />

                    <Button variant="contained" color="success" type="submit" disabled={isAuthenticating}>
                        Log In
                    </Button>
                    {
                        !!reqError && (
                            <Alert
                                severity="error"
                                variant="outlined"
                                sx={{ mt: 2 }}
                            >
                                <AlertTitle>Sign in failed</AlertTitle>
                                {getFriendlyError(reqError)}
                            </Alert>
                        )
                    }
                </FormControl>
            </section>
            <Footer />
        </form>
    )
}

export default LoginPage